import { MC_NOTIFY_STATUS } from '@/constant/constant'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { nvl } from '@/utils/stringUtil'

export const sickLeaveMethod = {
  data () {
    return {
    }
  },
  methods: {
    showStaffOrGroupName (notify) {
      if (notify.notifiedEuid) {
        return '(' + notify.notifiedEntityAbbr + ') ' + nvl(notify.chinNotifiedStaffName, '') + (notify.chinNotifiedStaffName ? ' ' : '') + nvl(notify.portNotifiedStaffName, '')
      } else if (notify.notifiedGid) {
        return '(' + notify.notifiedEntityAbbr + ') ' + nvl(notify.chinNotifiedGroupName, '') + (notify.chinNotifiedGroupName ? ' ' : '') + nvl(notify.portNotifiedGroupName, '')
      }
    },
    notifyStatus: function (notify) {
      if (notify.statusCode === MC_NOTIFY_STATUS.WAIT) {
        return ''
      } else if (notify.statusCode === MC_NOTIFY_STATUS.CANCEL) {
        return '(' + this.$t('Text.Cancel') + ', ' + momentWithHyphen(notify.viewedTime).format('YYYY-MM-DD hh:mm:ss') + ')'
      } else if (notify.statusCode === MC_NOTIFY_STATUS.READ) {
        return '(' + this.$t('Admin.SickLeave.Notify.Notified') + ', ' + momentWithHyphen(notify.viewedTime).format('YYYY-MM-DD hh:mm:ss') + ')'
      } else if (notify.statusCode === MC_NOTIFY_STATUS.REDIRECTED) {
        return '(' + this.$t('Admin.SickLeave.Notify.Redirected') + ', ' + momentWithHyphen(notify.viewedTime).format('YYYY-MM-DD hh:mm:ss') + ')'
      }
    },
    notifyClass: function (notify) {
      if (notify.statusCode === MC_NOTIFY_STATUS.CANCEL) {
        return 'error--text'
      } else {
        return 'success--text'
      }
    }
  }
}
